module.exports = __webpack_public_path__ + "img/feature-tile-icon-04.0a5ad019.svg";